import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { ReactComponent as Error } from "../../assets/icons/error.svg";
import ButtonFormOrder from "../ButtonFormOrder.jsx";
import { marcacionPortMantenerOrden } from "../../utils/analytics";

const styleModal = {
  position: "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#FFFFFF",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};

export default function ModalError({
  open = false,
  orden,
  setLoading,
  phoneNumber,
}) {
  const urlPago = () => {
    setLoading(true);
    window.location.href =
      "https://prepago.movistar.co/carrito?serviceNumber=" + phoneNumber + "&utm_source=boton&utm_medium=landing_boton&utm_campaign=campa_prepago_carrito&utm_term=landing&utm_content=may&utm_canal=recupe_carritos_porta_prepago";
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      disableEscapeKeyDown={true}
      disableAutoFocus={true}
    >
      <Box sx={styleModal}>
        <div className="metricas-popup-eliminar-orden flex flex-col items-center justify-center text-center space-y-7 text-[#313235] font-telefonica">
          <div>
            <Error />
          </div>
          <div className="mt-4">
            <span className="text-md ">
              Esta línea tiene una orden pendiente de pago.
            </span>
            <br></br>
            <span className="text-md ">
              Debes esperar 24Hrs desde el momento que la generaste, para
              reintentar la portabilidad.
            </span>
          </div>
        </div>
        <div className="px-2 flex flex-col justify-center text-center space-y-6 mt-4 text-[#313235] font-telefonica">
          <div>
            <ButtonFormOrder
              title="Quiero pagar mi orden pendiente"
              fullWidth={true}
              onClick={() => {
                marcacionPortMantenerOrden();
                urlPago();
              }}
              style={{
                backgroundColor: "#019df4",
                "&:hover": {
                  backgroundColor: "#019df4",
                  boxShadow: "none",
                },
              }}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}
